export default __webpack_public_path__ + "static/media/05-3.68370c91.jpg";